"use client";

import NextImage, { type ImageProps as NextImageProps } from "next/image";
import NextLink, { type LinkProps as NextLinkProps } from "next/link";

import { ReplacementPart as ReplacementPartComponent } from "@/composite/ReplacementPart";
import type { ProductsResponse } from "@/domain/product";
import type { ProductReference } from "@/types";
import type { ReplacementPart } from "@/types/references";
import { resolveImageProps } from "@/app/utilities/images";

import styles from "./styles.module.scss";

interface ReplacementPartBlockClientProps extends ReplacementPart {
	productsData: ProductReference[];
	productsResponse: ProductsResponse;
}

/**
 * Whats Included block component
 */
export function ReplacementPartBlock({
	productsData,
	productsResponse,
	...props
}: ReplacementPartBlockClientProps): JSX.Element {
	if (productsResponse?.type === "failure") {
		throw new Error(productsResponse.message);
	}

	return (
		<div className={styles["replacement-part"]}>
			<ReplacementPartComponent<NextImageProps, NextLinkProps>
				heading={{
					children: props.replacement_part_section_headline,
					tag: props.replacement_part_headline_tag
				}}
				description={props.replacement_part_description}
				subheading={{
					children: props.replacement_part_subheading,
					tag: props.replacement_part_subheading_tag
				}}
				info={props.replacement_part_content_description}
				product={
					productsData?.map((product) => {
						const productData = productsResponse?.products?.find(
							({ sku }) => sku === product.sku
						);

						return {
							image: {
								...resolveImageProps("1:1"),
								component: NextImage,
								src: productData?.image ?? "",
								alt: productData?.name ?? ""
							},
							cta: {
								children: product?.title ?? "",
								href:
									product?.meta_data?.canonical_url?.href ??
									"",
								component: NextLink
							},
							rating: {
								rating: productData?.starsRating ?? 0,
								label: productData?.numRatings
									? `(${productData?.numRatings})`
									: ""
							},
							price: {
								display: productData?.salePrice ?? 0
							}
						};
					})[0]
				}
			/>
		</div>
	);
}
